import { Button } from 'components/Button'
import { observer } from 'mobx-react-lite'
import { useTabRoot } from './TabRootStore'

import { ReactComponent as BackIcon } from 'assets/icons/arrowLeft16.svg'
import { ReactComponent as ForwardIcon } from 'assets/icons/arrowRight16.svg'
import { ReactComponent as StopIcon } from 'assets/img/x-icon.svg'
import { ReactComponent as ReloadIcon } from 'assets/icons/reload16.svg'

import Styles from './Controls.module.scss'
import { sendMessageToTab } from './utils'
import { useCallback } from 'react'
import cx from 'classnames'

export const Controls = observer(() => {
  const tabRoot = useTabRoot()
  const { isLoading } = tabRoot.currentTab
  const { canGoBack, canGoForward } = tabRoot.currentTab.history

  const goBack = useCallback(
    () => sendMessageToTab({ type: 'HistoryGoBack' }, tabRoot.currentTab),
    [tabRoot.currentTab],
  )
  const goForward = useCallback(
    () => sendMessageToTab({ type: 'HistoryGoForward' }, tabRoot.currentTab),
    [tabRoot.currentTab],
  )
  const reload = useCallback(() => sendMessageToTab({ type: 'ReloadPage' }, tabRoot.currentTab), [tabRoot.currentTab])

  return (
    <div className={Styles.controls}>
      <Button
        isDisabled={!canGoBack}
        frontIcon={BackIcon}
        variant="none"
        size="md"
        className={Styles.controlButton}
        onPress={goBack}
      />
      <Button
        isDisabled={!canGoForward}
        frontIcon={ForwardIcon}
        variant="none"
        size="md"
        className={Styles.controlButton}
        onPress={goForward}
      />
      <Button
        isDisabled={isLoading}
        frontIcon={isLoading ? StopIcon : ReloadIcon}
        variant="none"
        size="md"
        className={cx(Styles.controlButton, { [Styles.stopButton]: isLoading })}
        onPress={isLoading ? undefined : reload}
      />
    </div>
  )
})
